// Seasonal color variant grouping for PDP
(function() {
  // Update these to match your exact seasonal variant names in Shopify
  const SEASONAL_COLORS = ['Mahogany/Black', 'Navy/Maple'];

  function groupVariantSwatches() {
    // Horizon uses fieldset.variant-option--swatches for color options
    const fieldsets = document.querySelectorAll('fieldset.variant-option--swatches');

    fieldsets.forEach(function(fieldset) {
      // Confirm this is the Color option
      var legend = fieldset.querySelector('legend');
      if (!legend || !legend.textContent.includes('Color')) return;

      // Already processed?
      if (fieldset.querySelector('.seasonal-divider')) return;

      // Get all swatch labels (each label wraps an input + swatch visual)
      var allLabels = Array.from(fieldset.querySelectorAll('label.variant-option__button-label'));
      if (allLabels.length === 0) return;

      var seasonalLabels = [];

      allLabels.forEach(function(label) {
        var input = label.querySelector('input');
        var value = input ? input.value : '';
        if (SEASONAL_COLORS.some(function(sc) { return value === sc; })) {
          seasonalLabels.push(label);
        }
      });

      if (seasonalLabels.length === 0) return;

      // Create the divider heading
      var divider = document.createElement('div');
      divider.className = 'seasonal-divider';
      divider.innerHTML = '<span class="seasonal-divider__label">Seasonal Colors</span>';

      // Create a wrapper for seasonal swatches
      var seasonalGroup = document.createElement('div');
      seasonalGroup.className = 'seasonal-swatches';

      // Move seasonal labels into the new group
      seasonalLabels.forEach(function(label) {
        seasonalGroup.appendChild(label);
      });

      // Insert after the fieldset's existing swatch area
      fieldset.appendChild(divider);
      fieldset.appendChild(seasonalGroup);
    });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', groupVariantSwatches);
  } else {
    groupVariantSwatches();
  }

  // Re-run after Shopify section re-renders (theme editor, AJAX updates)
  document.addEventListener('shopify:section:load', groupVariantSwatches);

  // Observe DOM changes for dynamic re-renders
  var observer = new MutationObserver(function() {
    groupVariantSwatches();
  });
  var target = document.querySelector('.product-information, [data-product-form], main');
  if (target) {
    observer.observe(target, { childList: true, subtree: true });
  }
})();